/* eslint-disable no-console */

/**
 * prints *this*
 * @param {function} [logFunc=console.log] log function
 * @example
 * import {print} from 'js-utils';
 * "my string"::print();
 * @return {*} returns the return value from logFunc call
 */
export function print(logFunc = console.log) {
	return logFunc(this);
}
